"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_TYPES = void 0;
var OPEN_LS_DROPDOWN = 'LifeCycle states dropdown opened';
var CLICK_LS_INFO = 'LifeCycle info link clicked';
var LS_STATE_CHANGE = 'LifeCycle state changed';
var LS_STATE_CHANGE_ERROR = 'LifeCycle state change returned error';
var EVENT_TYPES = exports.EVENT_TYPES = {
  OPEN_LS_DROPDOWN: OPEN_LS_DROPDOWN,
  CLICK_LS_INFO: CLICK_LS_INFO,
  LS_STATE_CHANGE: LS_STATE_CHANGE,
  LS_STATE_CHANGE_ERROR: LS_STATE_CHANGE_ERROR
};
//# sourceMappingURL=events.js.map